import axios from 'axios'

/**
 * いま入っている端末の一覧と、切る操作。
 *
 * ここがやるのは表示と依頼だけ。**判断はしない。**
 *
 *   - どれが「いまの端末」かは、サーバが真偽値で返す
 *   - 誰のものかはサーバがセッションから決める
 *   - 切れたかどうかもサーバが決める
 *
 * ■ 画面が持たないもの
 *
 * サーバは `session_ref`（台帳の引き鍵）を返さない。画面が持つ理由が無く、
 * 持つと**再利用できる値を配る**ことになる。切るときに渡すのは行の番号
 * だけで、他人の番号を入れても、SQLが本人のぶんしか触らないので何も
 * 起きない。
 *
 * ■ 「この端末」をブラウザ側で当てない
 *
 * ユーザーエージェントやIPを見比べて自分で当てると、同じ端末が2つ並んだ
 * ときに間違える。**間違えると、いま使っているものを切って自分を締め出す。**
 * 当てずにサーバの印をそのまま使う。
 */

const BASE = process.env.VUE_APP_API_ORIGIN

/** いま入っている端末の一覧。新しい順。 */
export async function listSessions () {
  const response = await axios.get(BASE + '/auth/sessions')
  return Array.isArray(response.data) ? response.data : []
}

/**
 * 端末を1つ切る。
 *
 * <p>サーバは切れたかどうかしか返さない。件数だと、0 と 1 の違いから
 * 「その番号の行が他人のものとして存在する」ことを推せる。</p>
 */
export async function revokeSession (sessionRowId) {
  const response = await axios.delete(
    BASE + '/auth/sessions/' + encodeURIComponent(sessionRowId))
  return Boolean(response.data && response.data.revoked)
}

/**
 * ほかの端末を全部切る。いまのは残す。
 *
 * <p>いまのを一緒に切ると、押した本人がその場で締め出される。
 * 「心当たりのない端末がある」ときに押すものなので、押した人は
 * 作業を続けられないといけない。</p>
 */
export async function revokeOtherSessions () {
  const response = await axios.post(BASE + '/auth/sessions/revoke-others')
  return Number((response.data && response.data.revoked) || 0)
}

/*
 * 本人確認のやり直しを求められたか。
 *
 * **写さない。**同じ判定がパスキー側にあり、サーバは 403 と
 * code: REAUTHENTICATION_REQUIRED の両方を返す。403 だけで見ると、
 * 別の理由の 403 まで「入り直せば通る」と読んでしまう。
 *
 * 判定を2か所に置くと、片方だけ直して片方が残る。
 */
export { isReauthenticationRequired } from './passkey'

/**
 * 通信そのものが届かなかったか。
 *
 * <p>届かなかったのか、届いて断られたのかで、利用者へ言うことが変わる。
 * 一緒にすると「やり直せば切れるのか」が分からない。</p>
 */
export { isNetworkFailure } from './passkey'
